"use strict";
var StateAvailability = (function () {
    function StateAvailability() {
    }
    return StateAvailability;
}());
exports.StateAvailability = StateAvailability;
//# sourceMappingURL=D:/a/1/s/purchase/src/models/licensing/state-availability.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/models/licensing/state-availability.model.js